import React from 'react';

import { Flex } from '@qality/common-components/src/atoms/Flex';
import { SpinnerLoader } from '@qality/common-components/src/molecules/SpinnerLoader/SpinnerLoader';

import StatusScheme from '../StatusScheme';
import { useTestCaseExecutionStatusPageContext } from '../TestCaseExecutionStatusPageProvider';
import Header from './Header';
import { PageWrapperStyled } from './TestCaseExecutionStatus.styled';
import TestCaseExecutionStatusSectionMessage from './TestCaseExecutionStatusSectionMessage';

export default function TestCaseExecutionStatus(): JSX.Element {
  const { loading, isEditScreen, statuses } =
    useTestCaseExecutionStatusPageContext();

  const showSectionMessage =
    isEditScreen &&
    !(
      statuses.some((status) => status.category === 'PASSED') &&
      statuses.some((status) => status.category === 'FAILED')
    );

  if (loading === 'init') {
    return (
      <Flex justifyCenter paddingSize='medium'>
        <SpinnerLoader />
      </Flex>
    );
  }

  return (
    <PageWrapperStyled>
      <Header />
      {showSectionMessage && <TestCaseExecutionStatusSectionMessage />}
      <StatusScheme />
    </PageWrapperStyled>
  );
}
